const DOCUMENT = 'DISTRICTS_';

const actions = {
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  SHOW_MAKE_COPY_FOR_BRAND_MODAL: DOCUMENT + 'SHOW_MAKE_COPY_FOR_BRAND_MODAL',
  CLOSE_MAKE_COPY_FOR_BRAND_MODAL: DOCUMENT + 'CLOSE_MAKE_COPY_FOR_BRAND_MODAL',

  showMakeCopyForBrandModal: data => ({
    type: actions.SHOW_MAKE_COPY_FOR_BRAND_MODAL,
    payload: data,
  }),

  closeMakeCopyForBrandModal: () => ({
    type: actions.CLOSE_MAKE_COPY_FOR_BRAND_MODAL,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
